import { Injectable } from '@angular/core';
import { AppConfigService } from '../app-config-service/app-config.service';
import { AuthHttpClient } from '../auth-http-service/auth-http.service';
import { Patient } from '../../domain/patient';
import { Observable } from 'rxjs';
import { Response } from '@angular/http';

@Injectable()
export class PatientSearchService {

  // Injects the AppConfigService and the HttpClient needed to handle authorised users
  constructor(private appConfigService: AppConfigService, private http: AuthHttpClient) { }

  // Uses the maternity api to search fo a patient
  search(searchString: string, searchFilter: string): Observable<Response> {
    let searchUrl = this.appConfigService.SearchUrl.replace('{searchFilter}', searchFilter).replace('{query}', searchString);
    return this.http.get(searchUrl);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/patient-search-service/patient-search.service.ts